export default "__VITE_ASSET__67404302__"